module.exports = __webpack_public_path__ + "static/media/gp-sp2025_375.367f8caa.png";